import { Component, input } from '@angular/core';

@Component({
  selector: 'ui-app-footer',
  standalone: true,
  template: `
    <footer class="ui-app-footer">
      <span>{{ label() }} ©{{ year() }}</span>
      <span>Versão: {{ version() || '—' }}</span>
    </footer>
  `,
  styles: [`
    .ui-app-footer {
      display: flex;
      justify-content: space-between;
      gap: 0.75rem;
      flex-wrap: wrap;
      padding: 0.75rem 1.5rem;
      font-size: 0.8125rem;
      color: var(--text-muted);
      border-top: 1px solid var(--border-color);
      background: var(--surface-bg);
    }
  `],
})
export class UiAppFooterComponent {
  label = input('Plataforma Veitros');
  version = input('');
  year = input(new Date().getFullYear());
}
